import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import {makeToolTipUrl} from "utils/DBUtils";
import {enUSmessage} from 'i18n/en-US.js';

export const SegmentsToolTip = (props) => (
  <div>
    Filters a break so that only the selected reader segments can see it. Typical needed when you have two or more versions (i.e. national and retail) of same campaign.
  </div>
);

export const GenderedTargetsToolTip = (props) => (
  <div>
    Targets a break to the selected gender(s).
  </div>
);

export const StateFiltersToolTip = (props) => (
  <div>
    Targets a break to certain states. Default: All = National
  </div>
);

export const TargetZipCodesToolTip = (props) => (
  <div>
    Targets a break to readers in the specified zip-codes.
  </div>
);

export const BlockedZipCodesToolTip = (props) => (
  <div>
    Blocks a break from readers in the specified zip-codes
  </div>
);

export const ApplyAgeTargetingToolTip = (props) => (
  <div>
  Targets the break to readers within the specified age range.
  </div>
);

export const AgeTargetingCodesToolTip = (props) => (
  <div>
  Targets the break to readers within the specified age range.
  </div>
);

export const ApplyAgeGatingToolTip = (props) => (
  <div>
  Restricts the break to readers within the specified age groups for censorship purposes. (Ex: Alcohol campaigns can not be seen by users under 21).
  </div>
);

export const AgeGatingCodesToolTip = (props) => (
  <div>
  Restricts the break to readers within the specified age groups for censorship purposes. (Ex: Alcohol campaigns can not be seen by users under 21).
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/break-campaign-targeting-tool-tips.jsx